import React from 'react';

/* Loader animé Walter (public/brand/walter-loader.svg).
   Servi en <img> : les animations CSS internes au SVG tournent quand même,
   et le prefers-reduced-motion du fichier est respecté. */
export default function WalterLoader({ size = 100 }) {
    return (
        <img
            src="/brand/walter-loader.svg"
            width={size}
            height={size}
            alt="Chargement…"
            className="walter-loader"
        />
    );
}
